import { Trans } from "@lingui/react/macro";

import { useRankLookup } from "@/features/matches";

import { useAnalysis } from "../../api/useAnalysis";
import { useAssetLookup } from "../../api/useAssetLookup";

type BaselineLineProps = {
  analysisId: number;
  heroId: number;
};

// С кем сравнивает весь разбор — один раз внизу шапки (доска «3ж», StrongOnce.dc.html),
// дальше строки и подписи слово «сильные» не повторяют. Кольцо оценки рядом сравнивает
// с рангом игрока, эта строка — с эталоном разбора. Ранг эталона — из разбора
// (`details.baseline_min_badge`); у старых разборов его нет — строка без ранга.
// Разбор ещё готовится или упал — строки нет.
export const BaselineLine = ({ analysisId, heroId }: BaselineLineProps) => {
  const analysis = useAnalysis(analysisId);
  const heroName = useAssetLookup("heroes")(heroId).name;
  const rankLookup = useRankLookup();
  if (analysis.data?.status !== "done") {
    return null;
  }
  const badge = analysis.data.details?.baseline_min_badge ?? null;
  const rank = badge === null ? null : rankLookup(badge);
  const rankName = rank?.name;
  return (
    <p
      data-baseline-badge={badge ?? undefined}
      className="flex basis-full items-center gap-2.5 border-t border-border pt-3 text-[13px] text-muted"
    >
      {rank?.iconUrl && (
        <img src={rank.iconUrl} alt="" className="size-[26px] shrink-0 object-contain" />
      )}
      <span>
        {rankName === undefined ? (
          <Trans id="analysis.baseline.line">
            Below, you are compared with strong {heroName} players
          </Trans>
        ) : (
          <Trans id="analysis.baseline.line_rank">
            Below, you are compared with strong {heroName} players, rank{" "}
            <b className="font-semibold text-foreground">{rankName}</b> and above
          </Trans>
        )}
      </span>
    </p>
  );
};
